import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GridsterConfig, GridsterItem } from 'angular-gridster2';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { ActivityAPIService } from '../user/user-api.service';
import { NCESAPIService } from './nces.service';
import { TerritoryCardService } from '../territoryCard/territory-card.service';
import { ObjectCarouselComponent } from "../base/objectCarousel/object-carousel.component";

@Component({
	selector: 'app-nces',
	templateUrl: './nces.component.html',
	standalone: false
})
export class NCESComponent implements OnInit {
	constructor(
		private activityAPI: ActivityAPIService,
		private activatedRoute: ActivatedRoute,
		private userInfo: UserInfoService,
		private ncesAPI: NCESAPIService,
		private router: Router
		
	) { }

	status: number = 0;
	gridsterReady: boolean = false;
	schoolId: string = null;
	school: any = null;
	isAnonymous: boolean = this.userInfo.isAnonymous();
	isMobile: boolean = AppSettingService.widgetMobile();

	private setDisplay(): void {
		this.isMobile = AppSettingService.widgetMobile();
		this.status = 1;
	}

	@HostListener('window:resize', ['$event']) onResize(e: any): void {
		this.setDisplay();
	}

	//#region gridster items
	gridsterOptions: GridsterConfig = AppSettingService.gridsterOptions;

	gridsterResize(e: any): void {
		setTimeout(() => {
			this.gridsterReady = true;
		}, 500);
	}

	gstItems = {
		giNCESLogoCover: false,
		giProgressAction: false,
		giRegionalStatistics: false,
		giNCESNearby: false
	}

	gstItemSize = {
		logoCover: { x: 1, y: 0, cols: 10, rows: 2 } as GridsterItem,
		progressAction: { x: 1, y: 2, cols: 10, rows:4 } as GridsterItem,
		regionalStatistics: { x: 1, y: 6, cols: 10, rows: 6} as GridsterItem,
		nearby: { x: 1, y: 12, cols: 10, rows: 4 } as GridsterItem,
		update: () => {
			this.gstItemSize.nearby.rows = this.hasDataObj.nearby ? 4 : 1;
			try { this.gridsterOptions.api.optionsChanged(); }
			catch (ex) { ; }
		}
	}

	hasDataObj = {
		nearby: true
	};

	hasData(event: any, componentName: string) {
		let change: boolean = ((this.hasDataObj as any)[componentName] !== event) ? true : false;
		(this.hasDataObj as any)[componentName] = event;
		if (change) {
			this.gstItemSize.update();
		}
	}
	//#endregion gridster items

	private getSchool(): void {
		this.ncesAPI.getNCESSchool(this.schoolId).subscribe(
			response => {
				if (response.Object != null) {
					this.activityAPI.log('NCES', 'View', this.schoolId, '', '').subscribe();
					this.school = response.Object;
					this.status = 1;
					// delay some to wait for gridster finish the space for regional statistics
					setTimeout(() => { this.setDisplay(); }, 500);
				}
				else {
					this.status = 2;
					this.school = null;
					this.router.navigateByUrl("/Search");
				}
			},
			err => {
				console.log(err);
				this.status = 2;
				this.school = null;
				this.router.navigateByUrl("/Search");
			}
		);
	}

	ngOnInit(): void {
		this.gridsterResize = this.gridsterResize.bind(this);
		this.gridsterOptions.itemResizeCallback = this.gridsterResize;

		this.activatedRoute.paramMap.subscribe(params => {
			this.schoolId = params.get('schoolId');
			this.schoolId = this.schoolId == null ? "" : this.schoolId.trim();

			if (this.schoolId == "" || isNaN(this.school)) {
				this.router.navigateByUrl("/Search");
			}
			else {
				this.school = null;
				this.getSchool();
			}
		});
	};
}


@Component({
	selector: 'app-nces-nearby',
	templateUrl: "../base/objectCarousel/object-carousel.component.html",
	standalone: false
})
export class NCESNearbyComponent extends ObjectCarouselComponent {
	@Input() schoolId: string = "";

	constructor(
		private ncesAPI: NCESAPIService,
		protected tcs: TerritoryCardService
	) {
		super();
		this.componentName = "NCES Nearby Places";
		this.objectName = "Nearby Places";
	}

	protected override downloadData() {
		if (this.retrievingData || this.downloading || this.downloadComplete || this.schoolId === "") {
			return;
		}
		this.downloading = true;
		this.retrievingData = this.offset === 0 ? true : false;

		this.ncesAPI.getNCESSchoolNearby(this.schoolId, this.offset, this.limit).subscribe(
			response => {
				if (this.offset === 0) {
					if (response.Results.length > 0) {
						this.hasData.emit(true);
					}
					else {
						this.hasData.emit(false);
						this.noDataWidget = true;
					}
				}
				if (response.Results != null && response.Results.length > 0) {
					this.offset += this.limit;
					for (let i = 0; i < response.Results.length; i++) {
						super.addObjectItem(this.tcs.normalizeNCES(response.Results[i]));
					}
					this.noDataWidget = false;
					if (response.Results.length < this.limit) {
						this.downloadComplete = true;
					}
				}
				else {
					this.downloadComplete = true;
				}

				this.downloading = false;
				this.retrievingData = false;
			},
			error => {
				console.log(error);
				this.retrievingData = false;
				this.downloading = false;
				if (this.offset === 0) {
					this.hasData.emit(false);
					this.noDataWidget = true;
				}
			}
		);
	}
}
